<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import autofit from'autofit.js' //适配
export default {
  name: 'App',
  mounted(){
    // 适配,默认设置高度1920px
     autofit.init({
        dh: 1080,
        dw: 1920,
        // el:"#app",
        resize: true
    })

  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
html,body,#app{
  width: 100%;
  height: 100%;
}
</style>
